<template>
	<div class="py-4 container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card mb-4">
					<div class="card-header pb-0">
						<h4>Terapie</h4>
						<button
							type="button"
							id="add-btn"
							class="btn btn-primary"
							@click="clear"
							data-bs-toggle="modal"
							data-bs-target="#formModal"
						>
							+ Nuovo
						</button>
					</div>
					<div class="card-body px-0 pt-0 pb-2">
						<custom-table
							ref="table$"
							:rows="data"
							@action="runAction"
							:columns="[
								{
									title: 'Problema',
									type: 'text',
									data: 'health_problem.name',
								},
								{
									title: 'Data',
									type: 'date',
									data: 'date',
								},
								{
									title: 'Diagnosi',
									type: 'text',
									data: 'diagnosis',
								},
								{
									title: 'Note',
									type: 'text',
									data: 'note',
								},
							]"
							:actions="[
								{
									title: 'Modifica',
									tooltip: 'edit',
									key: 'edit',
								},
							]"
							:pagination="pagination"
							@page-changed="handlePageChange"
							@update-pagination="handlePaginationUpdate"
							@search-changed="handleSearchChange"
						/>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="formModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="add"
			aria-hidden="true"
		>
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="formModalBtn">Terapia</h5>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							style="color: black; font-size: 2rem"
						>
							<span
								aria-hidden="true"
								class="d-block"
								style="margin-top: -0.5rem"
								>&times;</span
							>
						</button>
					</div>
					<div class="modal-body">
						<Vueform ref="form$" v-model="health_problem" sync>
							<HiddenElement name="id" />
							<SelectElement
								name="health_problem_id"
								:native="false"
								label="Problema di salute"
								rules="required"
								:items="health_problems"
							/>
							<DateElement
								name="date"
								label="Data"
								rules="required"
							></DateElement>
							<textarea-element
								name="diagnosis"
								label="Diagnosi"
								rules=""
							></textarea-element>
							<textarea-element
								name="note"
								label="Note"
								rules=""
							></textarea-element>
							<hr />
							<MultifileElement
								name="horse_health_problem_images"
								:object="true"
								url="https://equiup-api.13bit.dev/api/horse-images/get-photo"
								preview-url="https://equiup-api.13bit.dev/api/horse-images/get-thumbnail"
								:upload-temp-endpoint="false"
								label="Upload Foto"
								view="gallery"
								:clickable="true"
								:drop="true"
								storeFile="url"
								:soft-remove="true"
							/>
						</Vueform>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							id="close"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Chiudi
						</button>
						<button
							type="button"
							class="btn btn-primary"
							:class="{ loading: loading }"
							@click="save"
						>
							Salva
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { horsesHealthProblemService } from '@/services/HorsesHealthProblemService';
	import CustomTable from '@/components/CustomTable';
	import { useToast } from 'vue-toastification';
	import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
	import { useTableData } from '../../composables/useTableData';
	const toast = useToast();

	export default {
		name: 'HorseHealthProblems',
		props: {
			id: {
				type: [String, Number],
				required: true,
			},
		},
		data() {
			return {
				loading: false,
				health_problem: {},
				health_problems: [],
			};
		},
		setup() {
			return useTableData(
				horsesHealthProblemService.getHorseHealthProblems.bind(
					horsesHealthProblemService
				),
				10
			);
		},
		mounted() {
			this.fetchData({ horse_id: this.id });
			horsesHealthProblemService.getHealthProblems().then(
				(problems) =>
					(this.health_problems = problems.map((p) => ({
						value: p.id,
						label: p.name,
					})))
			);
		},
		computed: {},
		components: {
			CustomTable,
		},
		created() {
			this.$store.dispatch('updateBreadcrumbs', [
				{ title: 'Lista Cavalli', name: 'Horses' },
				{ title: 'Cavallo', name: 'Horse', params: { id: this.id } },
				{ title: 'Salute', name: 'HorseHealth', params: { id: this.id } },
			]);
		},
		methods: {
			async runAction({ action, row }) {
				this.loading = true;
				if (action.key == 'edit') {
					horsesHealthProblemService
						.getHorseHealthProblemById(row.id)
						.then((problem) => {
							this.health_problem = problem;
							this.loading = false;
							const modalElement = document.getElementById('formModal');
							const myModal = new bootstrap.Modal(modalElement);
							myModal.show();
						});
				}
			},
			clear() {
				this.health_problem = {};
				this.$refs.form$.reset();
			},
			async save() {
				const form = this.$refs.form$;
				form.validate();
				if (this.health_problem.id) form.data.id = this.health_problem.id;
				form.data.horse_id = this.id;
				if (!form.hasErrors) {
					for (const key in form.data) {
						if (form.data[key] === 'null' || form.data[key] === null) {
							delete form.data[key];
						}
					}
					this.loading = true;
					try {
						await horsesHealthProblemService.saveHorseHealthProblem(form.data);
						toast(this.$t('operation_saved'));
						document.getElementById('close').click();
						this.fetchData({ horse_id: this.id });
					} finally {
						this.loading = false;
					}
				}
			},
		},
	};
</script>
